import React from "react";
import SvgRightCaret from "../../../../assets/icons/SvgRightCaret";

const MenuItem = ({ data, setDrawer, drawerName }) => {
  return (
    <button
      key={data.title}
      role="button"
      className="cursor-pointer font-bold text-xl py-[10px] pl-8 pr-[52px] flex justify-between items-center tracking-wide"
      onClick={() => setDrawer(drawerName)}
    >
      {data.title}
      <SvgRightCaret
        style={{
          position: "absolute",
          right: "32px",
          width: "12px",
          height: "12px",
          transform: "rotate(270deg)",
        }}
      />
    </button>
  );
};

export default MenuItem;
